import React, { useCallback, useState } from "react";
import { IProjectData } from "@src/models/shared/IProjectData";
import { ProjectsResponse } from "@src/models/ProjectsResponse";
import { StandaloneProjectPickerFluent9, StandaloneProjectPickerFluent9Props } from "./StandaloneProjectPickerFluent9";
import { withLocalize } from "react-localize-redux";

export interface ProjectPickerWithLoaderProps
    extends Omit<StandaloneProjectPickerFluent9Props, "projects" | "projectsLoading" | "onReloadProjects"> {
    getProjects: () => Promise<ProjectsResponse>;
}

export const ProjectPickerWithLoader = withLocalize((props: ProjectPickerWithLoaderProps) => {
    const { getProjects, ...pickerProps } = props;

    const [projects, setProjects] = useState<IProjectData[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [hasLoaded, setHasLoaded] = useState<boolean>(false);

    const loadProjects = useCallback(async () => {
        setLoading(true);
        try {
            const response = await getProjects();
            const mapped = response.projects.map((proj) => {
                const displayName = proj.number ? `${proj.number} - ${proj.name}` : proj.name;
                return {
                    name: proj.name,
                    number: proj.number,
                    displayName,
                    nrn: proj.nrn,
                    nixEnabled: proj.nixEnabled,
                    code: proj.code,
                };
            });
            setProjects(mapped);
        } catch (error) {
            props.logger.error("Failed to load projects", error instanceof Error ? error : new Error(String(error)));
            setProjects([]);
        }
        setLoading(false);
        setHasLoaded(true);
    }, [getProjects, props.logger]);

    React.useEffect(() => {
        if (!hasLoaded) {
            loadProjects();
        }
    }, [hasLoaded, loadProjects]);

    return (
        <StandaloneProjectPickerFluent9
            {...pickerProps}
            projects={projects}
            projectsLoading={loading}
            onReloadProjects={loadProjects}
        />
    );
});
